module.exports = __webpack_public_path__ + "img/video-icon.abe9fc02.png";